<template>
  <div class="home">
    <!-- banner -->
    <div class="banner">
      <div class="container">
        <div class="btn">
          <div class="campus_btn" @click="campus_btn">校园招聘</div>
          <div class="society_btn" @click="society_btn">社会招聘</div>
        </div>
      </div>
    </div>
    <div class="content">
      <!-- 公司介绍 -->
      <div class="company">
        <div class="container">
          <HomeTitle> 公司介绍 </HomeTitle>
          <div class="company_content">
            <div class="company_content_l">
              <p>
                安徽中科光电色选机械有限公司坐落于中国合肥，公司成立于2002年，占地面积230亩，员工人数1000余人，总投资1.5亿元人民币，拥有数字化生产车间27000平方米，科研楼25000平方米，专业从事高端装备制造，专注智能分选领域设备研发、生产、销售的高新技术企业。公司产品销售遍布国内30多个省市自治区，远销海外，出口60多个国家和地区。
              </p>
              <p>
                国家高新技术企业、国家企业技术中心、国家级博士后科研工作站、国家专精特新“小巨人”企业、安徽省工业设计中心、安徽省制造业服务示范企业、合肥工业大学共建智慧辨识与分拣工程技术中心。
              </p>
            </div>
            
            <div class="company_content_r">
              <video
                width="100%"
                height="100%"
                style="object-fit: cover"
                poster="../assets/img/videopic.jpg"
                controls
              >
                <source
                  src="http://job.cn-amd.com/15video.mp4"
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
          <div class="company_countTo">
            <div class="cou_item">
              <div class="item_text">
                <span>2</span><span>002</span><span>年</span>
              </div>
              <p>公司成立</p>
            </div>
            <div class="cou_item">
              <div><span>3</span><span>0000</span><span>+</span></div>
              <p>产品遍布全球</p>
            </div>
            <div class="cou_item">
              <div><span>2</span><span>00</span><span>+</span></div>
              <p>技术奖项</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 人才观念 -->
      <div class="personnel">
        <div class="container">
          <HomeTitle> 人才观念 </HomeTitle>
          <div class="personnel_swiper">
            <el-carousel
              indicator-position="none"
              :interval="3000"
              type="card"
              arrow="never"
              height="3.4rem"
            >
              <el-carousel-item v-for="(item, index) in personnel" :key="index">
                <div class="backimg">
                  <img class="img" :src="item.pic" alt="" />
                  <div class="opt"></div>
                  <div class="text">{{ item.text }}</div>
                  <div class="desc">{{ item.desc }}</div>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
      </div>
      <!-- 职场发展 -->
      <div class="workplace">
        <div class="container">
          <HomeTitle> 职场发展 </HomeTitle>
          <p class="h2_text">
            建立员工管理和专业双通道发展，共同打造员工职业发展体系。
          </p>
          <div class="p_box">
            <div class="box_top">
              <div class="box_text">职位</div>
              <div><i class="el-icon-arrow-right"></i></div>
              <div class="box_text">职级</div>
              <div><i class="el-icon-arrow-right"></i></div>
              <div class="box_text">职务</div>
            </div>
            <div class="box_btm">
              <div class="box_btm_l">
                <div>
                  <img src="@/assets/img/zc1.png" alt="" />
                </div>
                <p>人才</p>
              </div>
              <div class="box_btm_c btm_pc" v-if="!m">
                <ul class="con_ul">
                  <li class="dian"></li>
                  <li>办事员</li>
                  <li>助理工程师</li>
                  <li>助理工程师</li>
                  <li>初、中、高级工</li>
                  <li>实习销售</li>
                </ul>
                <ul class="con_ul">
                  <li class="dian"></li>
                  <li>专员</li>
                  <li>工程师</li>
                  <li>工程师</li>
                  <li>高级技工</li>
                  <li>销售经理</li>
                </ul>
                <ul class="con_ul">
                  <li class="dian"></li>
                  <li>主管</li>
                  <li>高级工程师</li>
                  <li>高级工程师</li>
                  <li>主管</li>
                  <li>区域部长</li>
                </ul>
                <ul class="con_ul">
                  <li class="dian"></li>
                  <li>部长</li>
                  <li>部长/产品经理</li>
                  <li>主任</li>
                  <li>部长</li>
                  <li>区域总监</li>
                </ul>
                <ul class="con_ul">
                  <li class="dian1"></li>
                  <li>副总</li>
                  <li>总监</li>
                  <li>总监</li>
                  <li>总监</li>
                  <li>副总</li>
                </ul>
                <ul class="con_ul ul_last">
                  <li style="width: 0.3rem; height: 0.3rem"></li>
                  <li>行政管理</li>
                  <li>产品开发</li>
                  <li>技术开发</li>
                  <li>工艺技能</li>
                  <li>市场营销</li>
                </ul>
              </div>
              <div class="box_m" v-else>
                <div class="box_btm_c">
                  <ul class="con_ul">
                    <li class="dian"></li>
                    <li>办事员</li>
                    <li>助理工程师</li>
                    <li>助理工程师</li>
                    <li>初、中、高级工</li>
                    <li>实习销售</li>
                  </ul>
                  <ul class="con_ul">
                    <li class="dian"></li>
                    <li>专员</li>
                    <li>工程师</li>
                    <li>工程师</li>
                    <li>高级技工</li>
                    <li>销售经理</li>
                  </ul>
                  <ul class="con_ul">
                    <li class="dian"></li>
                    <li>主管</li>
                    <li>高级工程师</li>
                    <li>高级工程师</li>
                    <li>主管</li>
                    <li>区域部长</li>
                  </ul>
                  <ul class="con_ul">
                    <li class="dian"></li>
                    <li>部长</li>
                    <li>部长/产品经理</li>
                    <li>主任</li>
                    <li>部长</li>
                    <li class="jt">区域总监</li>
                  </ul>
                  <ul class="con_ul">
                    <li class="dian1"></li>
                    <li>副总</li>
                    <li>总监</li>
                    <li>总监</li>
                    <li>总监</li>
                    <li class="jt">副总</li>
                  </ul>
                </div>
                <div class="m_ul">
                  <ul class="ul_last">
                    <li style="width: 0.3rem; height: 0.3rem"></li>
                    <li>行政管理</li>
                    <li>产品开发</li>
                    <li>技术开发</li>
                    <li>工艺技能</li>
                    <li>市场营销</li>
                  </ul>
                </div>
              </div>
              <div class="box_btm_r">
                <div>
                  <img src="@/assets/img/zc2.png" alt="" />
                </div>
                <p>核心骨干激励</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 员工成长 -->
      <div class="staff">
        <div class="container">
          <HomeTitle> 员工成长 </HomeTitle>
          <div class="staff_centent" v-if="!m">
            <StaffItem>
              <img slot="img" src="../assets/img/boshi.png" alt="" />
              <p slot="text">应届生培养</p>
              <!-- <p slot="desc">
                全面的入职培训，从公司文化、岗位职责、职业技能、业务范围等多角度展开培训，帮助应届生快速完成校园到职场的转变。
              </p> -->
            </StaffItem>
            <StaffItem>
              <img slot="img" src="../assets/img/geren2.png" alt="" />
              <p slot="text">社招新员工培养</p>
              <!-- <p slot="desc">
                全面了解公司、了解业务、了解文化、帮助新人安心/平稳落地。
              </p> -->
            </StaffItem>
            <StaffItem>
              <img slot="img" src="../assets/img/zuanshi-01.png" alt="" />
              <p slot="text">专业技术培养</p>
              <!-- <p slot="desc">
                结合公司职业通道发展体系及所需技术能力要求，建立各通道专业课程，搭建知识框架。
              </p> -->
            </StaffItem>
            <StaffItem>
              <img slot="img" src="../assets/img/cdd.png" alt="" />
              <p slot="text">花式培训</p>
              <!-- <p slot="desc">
                入职分享会、头脑风暴决策、技术经验传授会、领导力模型、职业健康心理学、安全健康活动会等让你乐享工作。
              </p> -->
            </StaffItem>
          </div>
          <div class="m_staff_centent" v-else>
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" style="height: 2.5rem">
                  <StaffItem>
                    <img slot="img" src="../assets/img/boshi.png" alt="" />
                    <p slot="text">应届生培养</p>
                  </StaffItem>
                </div>
                <div class="swiper-slide" style="height: 2.5rem">
                  <StaffItem>
                    <img slot="img" src="../assets/img/geren2.png" alt="" />
                    <p slot="text">社招新员工培养</p>
                  </StaffItem>
                </div>
                <div class="swiper-slide" style="height: 2.5rem">
                  <StaffItem>
                    <img slot="img" src="../assets/img/zuanshi-01.png" alt="" />
                    <p slot="text">专业技术培养</p>
                  </StaffItem>
                </div>
                <div class="swiper-slide" style="height: 2.5rem">
                  <StaffItem>
                    <img slot="img" src="../assets/img/cdd.png" alt="" />
                    <p slot="text">花式培训</p>
                  </StaffItem>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 薪酬福利 -->
      <div class="pay">
        <div class="container">
          <HomeTitle> 薪酬福利 </HomeTitle>
          <!-- <ul class="pay_content">

            <li>
              <div class="li_img">
                <img src="../assets/img/pic01.png" alt="" />
              </div>
              <p>固定薪酬</p>
            </li>
            <li>
              <div class="li_img">
                <img src="../assets/img/pic02.png" alt="" />
              </div>
              <p>项目绩效奖金、年终奖</p>
            </li>
            <li>
              <div class="li_img">
                <img src="../assets/img/pic03.png" alt="" />
              </div>
              <p>核心骨干激励计划</p>
            </li>
            <li>
              <div class="li_img">
                <img src="../assets/img/pic04.png" alt="" />
              </div>
              <p>班车、食堂、住宿</p>
            </li>
          </ul> -->
          <div class="xc">
            <svg width="100%" height="100%" class="slide_1">
              <ellipse
                cx="50.7%"
                cy="50%"
                rx="26%"
                ry="30.5%"
                style="fill: none; stroke: #1170ff; stroke-width: 1.5"
                class="ellipse"
              ></ellipse>
            </svg>
            <svg width="100%" height="100%" class="slide2-svg">
              <ellipse
                cx="50.7%"
                cy="50%"
                rx="40%"
                ry="46.5%"
                style="fill: none; stroke: #1170ff; stroke-width: 1.5"
                class="ellipse1"
              ></ellipse>
            </svg>
            <a class="a1" href="javascript:;">节日福利</a>
            <a class="a2" href="javascript:;">食堂</a>
            <a class="a3" href="javascript:;">年度体检</a>
            <a class="a4" href="javascript:;">旅游</a>
            <a class="a5" href="javascript:;">运动场</a>
            <a class="a6" href="javascript:;">生日会</a>
            <a class="a7" href="javascript:;">住宿</a>
            <a class="a8" href="javascript:;">婚/产假礼金</a>
            <a class="a9" href="javascript:;">薪资</a>
            <a class="a10" href="javascript:;">年终奖</a>
            <a class="a11" href="javascript:;">项目奖</a>
            <a class="a12" href="javascript:;">绩效工资</a>
            <span>
              <img src="../assets/img/fl01.png" alt="" />
            </span>
          </div>
        </div>
      </div>
      <!-- 招聘流程 -->
      <div class="recruit">
        <div class="container">
          <HomeTitle> 招聘流程 </HomeTitle>
          <div class="recruit_con">
            <div class="li">
              <div class="box">
                <div class="text">网申</div>
                <div class="icon">
                  <img src="../assets/img/biaoji.png" alt="" />
                </div>
                <!-- <div class="line">
                  <div class="line_st"></div>
                </div> -->
                <div class="light"></div>
              </div>
            </div>
            <div class="li">
              <div class="box">
                <div class="light"></div>
                <!-- <div class="line">
                  <div class="line_st"></div>
                </div> -->
                <div class="icon">
                  <img src="../assets/img/ruzhu.png" alt="" />
                </div>

                <div class="text">
                  技术面试
                  <!-- <span class="x">02</span> -->
                  <!-- <span class="m">技术面试</span> -->
                </div>
              </div>
            </div>
            <div class="li">
              <div class="box">
                <div class="text">综合面试</div>
                <div class="icon">
                  <img src="../assets/img/wanchengrenwu.png" alt="" />
                </div>
                <!-- <div class="line">
                  <div class="line_st"></div>
                </div> -->
                <div class="light"></div>
              </div>
            </div>
            <div class="li">
              <div class="box">
                <div class="text">录用签约</div>
                <div class="icon">
                  <img src="../assets/img/biaoqian.png" alt="" />
                </div>
                <!-- <div class="line">
                  <div class="line_st"></div>
                </div> -->
                <div class="light"></div>
              </div>
            </div>
            <div class="li">
              <div class="box">
                <div class="text">体检入职</div>
                <div class="icon">
                  <img src="../assets/img/gerenzhongxin.png" alt="" />
                </div>
                <!-- <div class="line">
                  <div class="line_st"></div>
                </div> -->
                <div class="light"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 工作环境 -->
      <div class="work">
        <div class="con">
          <HomeTitle> 工作环境 </HomeTitle>
          <div class="work_content">
            <!-- <ul class="work_ul" v-if="!m">
              <li class="work_li">
                <div class="li_img">
                  <img src="../assets/img/work_01.jpg" alt="" />
                </div>
              </li>
              <li class="work_li">
                <div class="li_img">
                  <img src="../assets/img/work_02.jpg" alt="" />
                </div>
              </li>
              <li class="work_li">
                <div class="li_img">
                  <img src="../assets/img/work_03.jpg" alt="" />
                </div>
              </li>
              <li class="work_li">
                <div class="li_img">
                  <img src="../assets/img/work_04.jpg" alt="" />
                </div>
              </li>

              <li class="work_li">
                <div class="li_img">
                  <img src="../assets/img/work_05.jpg" alt="" />
                </div>
              </li>
              <li class="work_li">
                <div class="li_img">
                  <img src="../assets/img/work_06.jpg" alt="" />
                </div>
              </li>
            </ul> -->
            <div v-if="!m">
              <div class="mySwiper4">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" style="width: 4rem">
                    <img src="../assets/img/gzhj_01.jpg" alt="" />
                  </div>
                  <div class="swiper-slide" style="width: 8.1rem">
                    <img src="../assets/img/gzhj_03.jpg" alt="" />
                  </div>
                  <div class="swiper-slide" style="width: 8.1rem">
                    <img src="../assets/img/gzhj_05.jpg" alt="" />
                  </div>
                  <div class="swiper-slide" style="width: 4rem">
                    <img src="../assets/img/gzhj_07.jpg" alt="" />
                  </div>
                  <div class="swiper-slide" style="width: 4rem">
                    <img src="../assets/img/gzhj_09.jpg" alt="" />
                  </div>
                  <div class="swiper-slide" style="width: 4rem">
                    <img src="../assets/img/gzhj_11.jpg" alt="" />
                  </div>
                  <div class="swiper-slide" style="width: 8.1rem">
                    <img src="../assets/img/gzhj_13.jpg" alt="" />
                  </div>
                  <div class="swiper-slide" style="width: 8.1rem">
                    <img src="../assets/img/gzhj_15.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
            <div class="m_work_ul" v-else>
              <div class="swiper mySwiper2">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" style="padding: 0 1.8rem">
                    <img src="../assets/img/gzhj_01.jpg" alt="" />
                  </div>
                  <div class="swiper-slide">
                    <img src="../assets/img/gzhj_03.jpg" alt="" />
                  </div>
                  <div class="swiper-slide">
                    <img src="../assets/img/gzhj_05.jpg" alt="" />
                  </div>
                  <div class="swiper-slide" style="padding: 0 1.8rem">
                    <img src="../assets/img/gzhj_07.jpg" alt="" />
                  </div>
                  <div class="swiper-slide" style="padding: 0 1.8rem">
                    <img src="../assets/img/gzhj_09.jpg" alt="" />
                  </div>
                  <div class="swiper-slide" style="padding: 0 1.8rem">
                    <img src="../assets/img/gzhj_11.jpg" alt="" />
                  </div>
                  <div class="swiper-slide">
                    <img src="../assets/img/gzhj_13.jpg" alt="" />
                  </div>
                  <div class="swiper-slide">
                    <img src="../assets/img/gzhj_15.jpg" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 企业关怀 -->
      <div class="care">
        <div class="container">
          <HomeTitle> 企业关怀 </HomeTitle>
          <div class="care_content" v-if="!m">
            <div class="care_img">
              <img src="../assets/img/fl.jpg" alt="" />
              <div class="care_img_opt">
                <div class="opt_img">
                  <img class="pic" src="../assets/img/ico_03.png" alt="" />
                </div>
                <div class="opt_text">
                  <h4>关心</h4>
                  <p>生日福利、慰问抚恤、健康体检、婚产假礼金</p>
                </div>
              </div>
            </div>
            <div class="care_img">
              <img src="../assets/img/fl1.jpg" alt="" />
              <div class="care_img_opt">
                <div class="opt_img">
                  <img class="pic" src="../assets/img/ico_04.png" alt="" />
                </div>
                <div class="opt_text">
                  <h4>贴心</h4>
                  <p>部门“小秘书”、免费餐厅、免费宿舍、话费/交通补贴......</p>
                </div>
              </div>
            </div>
            <div class="care_img">
              <img src="../assets/img/fl_01.jpg" alt="" />
              <div class="care_img_opt">
                <div class="opt_img">
                  <img
                    class="pic"
                    src="../assets/img/gerenzhongxin.png"
                    alt=""
                  />
                </div>
                <div class="opt_text">
                  <h4>爱心</h4>
                  <p>
                    入职辅助、带薪休假、Team
                    buildling、员工家庭日、体育竞赛......
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="m_care_content" v-else>
            <div class="swiper mySwiper3" style="width: 100%; height: 100%">
              <div class="swiper-wrapper">
                <div class="swiper-slide">
                  <div class="care_img">
                    <img src="../assets/img/fl.jpg" alt="" />
                    <div class="care_img_opt">
                      <div class="opt_img">
                        <img
                          class="pic"
                          src="../assets/img/ico_03.png"
                          alt=""
                        />
                      </div>
                      <div class="opt_text">
                        <h4>关心</h4>
                        <p>生日福利、慰问抚恤、健康体检、婚产假礼金</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="care_img">
                    <img src="../assets/img/fl1.jpg" alt="" />
                    <div class="care_img_opt">
                      <div class="opt_img">
                        <img
                          class="pic"
                          src="../assets/img/ico_04.png"
                          alt=""
                        />
                      </div>
                      <div class="opt_text">
                        <h4>贴心</h4>
                        <p>
                          部门“小秘书”、免费餐厅、免费宿舍、话费/交通补贴......
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-slide">
                  <div class="care_img">
                    <img src="../assets/img/fl_01.jpg" alt="" />
                    <div class="care_img_opt">
                      <div class="opt_img">
                        <img
                          class="pic"
                          src="../assets/img/gerenzhongxin.png"
                          alt=""
                        />
                      </div>
                      <div class="opt_text">
                        <h4>爱心</h4>
                        <p>
                          入职辅助、带薪休假、Team
                          buildling、员工家庭日、体育竞赛......
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import HomeTitle from "@/components/HomeTitle.vue";
import StaffItem from "@/components/StaffItem.vue";
import Footer from "@/components/Footer.vue";
// import { WOW } from "wowjs";
import Swiper from "swiper/js/swiper.esm.browser.bundle";
import "../assets/css/swiper.min.css";
export default {
  props: {},
  data() {
    return {
      m: false,
      personnel: [
        {
          text: "专注",
          desc: "潜心笃志",
          pic: require("../assets/img/zk3.jpg"),
        },
        {
          text: "学习",
          desc: "知行合一",
          pic: require("../assets/img/zk2.jpg"),
        },
        {
          text: "责任",
          desc: "恪尽职守",
          pic: require("../assets/img/zk1.jpg"),
        },
        {
          text: "执行",
          desc: "躬行实践",
          pic: require("../assets/img/wwwzk.jpg"),
        },
      ],

      screenWidth: document.body.clientWidth,
    };
  },
  computed: {},
  created() {
    if (this.screenWidth < 766) {
      this.m = true;
      console.log(this.m);
    }
  },
  mounted() {
    // Swiper
    new Swiper(".swiper-container", {
      slidesPerView: 2,
      freeMode: true,
    });
    new Swiper(".mySwiper2", {
      autoplay: true,
      loop: true,
    });
    new Swiper(".mySwiper3", {
      speed: 1500,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        waitForTransition: false,
      },
    });
    new Swiper(".mySwiper4", {
      autoplay: true,
      loop: true,
      slidesPerView: "auto",
      spaceBetween: 20,
    });

    //
    $(function () {
      $(".recruit_con .li").eq(0).addClass("cur");
      var LightNum = 0,
        LightAuto = setInterval(function () {
          LightNum++;

          if (LightNum == $(".recruit_con .li").length) {
            LightNum = 0;
          }

          $(".recruit_con .li")
            .eq(LightNum)
            .addClass("cur")
            .siblings()
            .removeClass("cur");
        }, 3000);
    });
  },
  watch: {},
  methods: {
    campus_btn() {
      // 跳转网址 https://app.mokahr.com/m/campus-recruitment/hdzn/151324?locale=zh-CN
      window.open("https://app.mokahr.com/m/campus-recruitment/hdzn/151324?locale=zh-CN");
      // this.$router.push("/campus");
    },
    society_btn() {
      window.open("https://app.mokahr.com/m/social-recruitment/hdzn/151323?locale=zh-CN")
      // this.$router.push("/society");
    },
  },
  components: {
    HomeTitle,
    StaffItem,
    Footer,
  },
};
</script>

<style lang="less" scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}
.el-carousel__item {
  width: 6rem;
}
.el-carousel__item {
  background-color: #99a9bf;
}
.el-carousel__item--card.is-active {
  .text {
    color: #fff !important;
    z-index: 1;
  }
  .desc {
    z-index: 1;
  }
  .opt {
    background-color: #ffffff00 !important;
  }
  .backimg {
    .opt {
      background-color: #1c60dd4d !important;
    }
  }
}
// .el-carousel__item:nth-child(2n + 1) {
//   background-color: #d3dce6;
// }
.dotCircle {
  background-image: url("../assets/img/xzback.png");
  background-size: cover;
}
@keyframes Circle {
  0% {
    transform: scale(0.5);
    opacity: 0;
  }

  50% {
    transform: scale(1);
    opacity: 0.3;
  }

  100% {
    transform: scale(0.5);
    opacity: 0;
  }
}

.home {
  margin-top: 0.8rem;
  .banner {
    width: 100%;
    height: 5.9rem;
    background-image: url("../assets/img/ban.jpg");
    background-position: center center;
    background-size: cover;
    background-repeat: no-repeat;
    .container {
      .btn {
        width: 100%;
        height: 5.92rem;
        position: relative;
        div {
          text-align: center;
          background-color: #fff;
          border-radius: 0.5rem;
          font-size: 0.18rem;
          padding: 0.1rem 0.3rem;
          color: #336fd1;
          font-weight: 600;
          white-space: nowrap;
          cursor: pointer;
        }
        .campus_btn {
          position: absolute;
          left: 39%;
          top: 56%;
        }
        .campus_btn:hover {
          background-color: #ff8a12;
          transition: background-color 0.3s;
          color: #fff;
        }
        .society_btn {
          position: absolute;
          left: 52%;
          top: 56%;
        }
        .society_btn:hover {
          background-color: #ff8a12;
          transition: background-color 0.3s;
          color: #fff;
        }
      }
    }
  }
  .content {
    // 公司介绍
    .company {
      width: 100%;
      height: 8rem;
      .container {
        .company_content {
          margin-top: 0.7rem;
          width: 100%;
          height: 3.95rem;
          display: flex;
          .company_content_l {
            width: 50%;
            height: 100%;
            background-color: #f3f7fa;
            padding: 0.4rem;
            overflow: hidden;
            background-image: url("../assets/img/jsback.png");
            background-position: center;
            background-repeat: no-repeat;
            p {
              text-indent: 2em;
              line-height: 0.4rem;
              font-size: 0.14rem;
            }
          }
          .company_content_r {
            width: 50%;
            height: 100%;
            background-color: #fafafa;
            padding: 0.4rem 0.2rem;
          }
        }
        .company_countTo {
          height: 1.5rem;
          margin-top: 0.2rem;
          background-color: #f3f7fa;
          display: flex;
          justify-content: space-around;
          align-items: center;
          .cou_item {
            div {
              display: flex;
              align-items: flex-start;
              span {
                font-size: 0.5rem;
                font-weight: 600;
                font-family: "Noto Sans SC";
              }
              span:nth-child(3) {
                font-size: 0.28rem;
              }
            }
            .item_text {
              align-items: baseline;
            }
            p {
              text-align: center;
            }
          }
        }
      }
    }
    // 人才队伍
    .personnel {
      width: 100%;
      height: 7.8rem;
      background-image: url("../assets/img/rcback.png");
      background-position: center;
      background-size: cover;
      background-color: #fafafa;
      .personnel_swiper {
        margin-top: 1.1rem;

        .backimg {
          width: 100%;
          height: 100%;
          position: relative;
          background-color: #3369c1;
          .opt {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            left: 0;
            z-index: 1;
            background-color: #c6c7c894;
          }
          .img {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
          }
          .text {
            position: absolute;
            font-size: 0.9rem;
            font-family: "Noto Serif SC";
            font-weight: 900;
            font-style: italic;
            color: #3369c1;
            top: 1rem;
            left: 50%;
            transform: translateX(-50%);
          }
          .desc {
            font-size: 0.3rem;
            font-family: "Noto Serif SC";
            font-weight: 700;
            font-style: italic;
            color: #fff;
            height: 1.15rem;
            width: 100%;
            background-color: #003790ad;
            position: absolute;
            left: 0;
            bottom: 0;
            text-align: center;
            line-height: 1.15rem;
          }
        }
      }
    }
    // 员工成长
    .staff {
      width: 100%;
      height: 5rem;
      background-color: #f3f7fa;
      .container {
        .staff_centent {
          display: flex;
          justify-content: space-between;
          margin-top: 0.6rem;
        }
        .m_staff_centent {
          display: none;
        }
      }
    }
    // 职场发展
    .workplace {
      width: 100%;
      height: 8rem;
      background-color: #f3f7fa;
      .container {
        .h2_text {
          text-align: center;
          margin-top: 0.5rem;
          font-family: "Noto Sans SC";
          font-size: 0.18rem;
        }
        .p_box {
          .box_top {
            display: flex;
            justify-content: space-evenly;
            align-items: center;
            width: 100%;
            height: 1.3rem;
            margin-top: 0.2rem;
            border-radius: 0.2rem;
            background-color: #d0e7f9;
            div {
              font-size: 0.2rem;
              color: #1170ff;
              i {
                font-size: 0.28rem;
              }
            }
            .box_text {
              width: 0.64rem;
              height: 0.64rem;
              line-height: 0.64rem;
              text-align: center;
              border-radius: 50%;
              color: #fff;
              font-family: "Noto Sans SC";
              background: linear-gradient(340deg, #1170ff, #d4e2f5);
            }
          }
          .box_btm {
            margin-top: 0.3rem;
            height: 4rem;
            display: flex;
            justify-content: space-between;
            .box_btm_l,
            .box_btm_r {
              width: 1.8rem;
              height: 100%;
              background-color: #d0e7f9;
              border-radius: 0.2rem;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              div {
                width: 0.64rem;
                height: 0.64rem;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              p {
                font-size: 0.18rem;
                text-align: center;
              }
            }
            .box_btm_c,
            .box_m > .box_btm_c {
              width: 7.8rem;
              height: 100%;
              position: relative;
              background-color: #d0e7f9;
              border-radius: 0.2rem;
              display: flex;
              justify-content: space-around;
              .con_ul {
                display: flex;
                align-items: center;
                flex-direction: column;
                justify-content: space-evenly;
                li {
                  width: 1.3rem;
                  text-align: center;
                }
                .dian,
                .dian1 {
                  width: 0.3rem;
                  height: 0.3rem;
                  background-color: #8fbaff;
                  border-radius: 50%;
                  position: relative;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                }

                .dian::before,
                .dian1::before {
                  content: "";
                  position: absolute;
                  width: 0.12rem;
                  height: 0.12rem;
                  background-color: #fff;
                  border-radius: 50%;
                }
                .dian::after {
                  content: "------>";
                  position: absolute;
                  left: 0.1rem;
                  width: 1.3rem;
                  color: #8fbaff;
                }
              }
              .ul_last {
                font-family: "Noto Sans SC";
              }
            }
            .btm_pc::after {
              content: "";
              position: absolute;
              background-image: url("../assets/img/arrow_01.png");
              background-size: 100%;
              background-repeat: no-repeat;
              background-position: center;
              width: 4.6rem;
              height: 1.4rem;
              left: 4.5rem;
              top: 0.05rem;
            }
          }
        }
      }
    }
    // 薪酬福利
    .pay {
      width: 100%;
      height: 9rem;
      background-image: url("../assets/img/fuli1.jpg");
      background-repeat: no-repeat;
      background-size: cover;
      .container {
        // .pay_content {
        //   display: flex;
        //   justify-content: space-evenly;
        //   margin-top: 1rem;
        //   li {
        //     p {
        //       text-align: center;
        //       font-size: 0.14rem;
        //     }
        //     .li_img {
        //       display: flex;
        //       justify-content: center;
        //       width: 1.2rem;
        //       height: 1.2rem;
        //       margin: 0 auto;
        //     }
        //   }
        // }
        .xc {
          height: 5rem;
          width: 12rem;
          top: 1rem;
          background-image: url("../assets/img/xc_back.png");
          background-size: 100%;
          background-repeat: no-repeat;
          background-position: center;
          position: relative;
          .slide_1 {
            .ellipse {
              stroke-dasharray: 0 300;
              stroke-dashoffset: -210;
              transition: 1s all ease;
            }
          }
          .slide2-svg {
            position: absolute;
            .ellipse1 {
              stroke-dasharray: 0 400;
              stroke-dashoffset: -220;
              transition: 1s all ease;
            }
          }

          .slide2-svg {
            left: 1px;
            top: 1px;
          }
          .slide_1 {
            left: 0;
            top: 0;
          }

          span {
            position: absolute;
            width: 3.4rem;
            height: 1.5rem;
            top: 36%;
            left: 50%;
            transform: translateX(-50%);
            img {
              width: 100%;
              height: 100%;
              transform: scale(0.8);
              transition: 0.5s all;
            }
          }
          a {
            font-size: 0.16rem;
            color: #4e4e4e;
            font-family: "Noto Sans SC";
            position: absolute;
          }
          a:hover {
            color: #1170ff;
            font-size: 0.18rem;
            font-weight: 600;
          }
          .a1 {
            left: 2.7rem;
            top: 0.3rem;
          }
          .a2 {
            left: 1.2rem;
            top: 1.4rem;
          }
          .a3 {
            left: 0.9rem;
            top: 3.4rem;
          }
          .a4 {
            left: 2.9rem;
            top: 4.4rem;
          }
          .a5 {
            left: 8.9rem;
            top: 4.4rem;
          }
          .a6 {
            left: 10.8rem;
            top: 3.4rem;
          }
          .a7 {
            left: 10.8rem;
            top: 1.4rem;
          }
          .a8 {
            left: 8.8rem;
            top: 0.3rem;
          }
          .a9 {
            left: 3.9rem;
            top: 0.9rem;
          }
          .a10 {
            left: 3.8rem;
            top: 3.9rem;
          }
          .a11 {
            left: 7.8rem;
            top: 3.9rem;
          }
          .a12 {
            left: 7.8rem;
            top: 0.9rem;
          }
        }
        .xc:hover {
          .slide_1 {
            .ellipse {
              stroke-dasharray: 170 0;
              stroke-dashoffset: 0;
            }
          }
          .slide2-svg .ellipse1 {
            stroke-dasharray: 370 0;
            stroke-dashoffset: 0;
          }
          span {
            img {
              transform: scale(1);
            }
          }
        }
      }
    }
    // 招聘流程
    .recruit {
      width: 100%;
      height: 6.8rem;
      background-image: url("../assets/img/recruit_back.jpg");
      background-size: cover;
      background-position: center;
      .container {
        .recruit_con {
          height: 5.7rem;
          position: relative;

          .cur {
            .box {
              .light::after {
                animation: Circle 1.2s infinite linear;
              }
              .icon {
                background: linear-gradient(
                  340deg,
                  #1170ff,
                  #d4e2f5
                ) !important;
              }
              .text {
                color: #1170ff !important;
              }
            }
          }
          .li {
            width: 0.75rem;
            height: 1.75rem;
            position: absolute;
            .box {
              width: 100%;
              height: 100%;
              position: relative;
              .light {
                width: 0.18rem;
                height: 0.18rem;
                border-radius: 50%;
              }
              .text {
                position: absolute;
                color: #b1b0b0;
                .x {
                  font-size: 0.24rem;
                }
                .m {
                  font-size: 0.14rem;
                  margin-left: 0.05rem;
                }
              }
            }
          }
          .li:nth-child(even) {
            top: 50%;
            .box {
              .light {
                position: absolute;

                transform: translateX(-50%);
                z-index: 1;
                background-color: #1170ff;
              }
              .light::after {
                content: "";
                position: absolute;
                left: -0.06rem;
                top: -0.06rem;
                z-index: 1;
                width: 0.3rem;
                height: 0.3rem;
                border-radius: 50%;
                opacity: 0.3;
                background-color: #1170ff;
                // animation: Circle 1.2s infinite linear;
              }
              .icon {
                width: 0.7rem;
                height: 0.7rem;
                border-radius: 50%;
                margin: 0 auto;
                position: absolute;
                bottom: 0;
                background-color: #b1b0b0;
                img {
                  width: 100%;
                  padding: 0.15rem;
                }
              }
              .line {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                bottom: 0.7rem;
                width: 100%;
                height: calc(100% - 0.7rem);
                .line_st::after {
                  content: "";
                  position: absolute;
                  left: 50%;
                  top: 0;
                  transform: translateX(-50%);
                  width: 2px;
                  height: 1.2rem;
                }
              }
            }
          }
          .li:nth-child(odd) {
            bottom: 50%;
            .box {
              .light {
                position: absolute;
                // bottom: -0.09rem;
                // left: 50%;
                transform: translateX(-50%);
                z-index: 1;
                background-color: #1170ff;
              }
              .light::after {
                content: "";
                position: absolute;
                left: -0.06rem;
                top: -0.06rem;
                z-index: 1;
                width: 0.3rem;
                height: 0.3rem;
                border-radius: 50%;
                opacity: 0.3;
                background-color: #1170ff;
                // animation: Circle 1.2s infinite linear;
              }
              .icon {
                width: 0.7rem;
                height: 0.7rem;
                border-radius: 50%;
                margin: 0 auto;
                background-color: #b1b0b0;
                img {
                  width: 100%;
                  padding: 0.15rem;
                }
              }
              .line {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                top: 0.7rem;
                width: 100%;
                height: calc(100% - 0.7rem);

                .line_st::after {
                  content: "";
                  position: absolute;
                  left: 50%;
                  top: 0;
                  transform: translateX(-50%);
                  width: 2px;
                  height: 1rem;
                }
              }
            }
          }
          .li:nth-child(1) {
            left: 1.5rem;
            bottom: 40%;
            .box {
              .light {
                left: 50%;
                bottom: 0.52rem;
              }
              .line {
                .line_st::after {
                  background-color: #1170ff;
                }
              }
              .text {
                right: 50%;
                transform: translateX(50%);
                bottom: 0;
                width: 100%;
                text-align: center;
              }
            }
          }
          .li:nth-child(2) {
            left: 3.7rem;
            top: 2.44rem;
            .light {
              left: 50%;
              top: 30%;
            }
            .line {
              .line_st::after {
                background-color: #1170ff;
              }
            }
            .text {
              right: 50%;
              transform: translateX(50%);
              bottom: 1.5rem;
              width: 100%;
              text-align: center;
            }
          }
          .li:nth-child(3) {
            left: 5.64rem;
            bottom: 2.45rem;
            .light {
              left: 50%;
              bottom: 30%;
            }
            .box {
              .line {
                .line_st::after {
                  background-color: #1170ff;
                }
              }
            }
            .text {
              right: 50%;
              transform: translateX(50%);
              bottom: 0;
              width: 100%;
              text-align: center;
            }
          }
          .li:nth-child(4) {
            left: 7.8rem;
            top: 2.36rem;
            .light {
              left: 50%;
              top: 30%;
            }
            .line {
              .line_st::after {
                background-color: #1170ff;
              }
            }
          }
          .li:nth-child(5) {
            left: 10rem;
            bottom: 1.96rem;
            .light {
              left: 50%;
              bottom: 30%;
            }
            .box {
              .line {
                .line_st::after {
                  background-color: #1170ff;
                }
              }
            }
            .text {
              right: 50%;
              transform: translateX(50%);
              bottom: 0;
              width: 100%;
              text-align: center;
            }
          }
        }
        .recruit_con::after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          width: 100%;
          height: 3rem;
          // background-color: #ff8a12;
          background-image: url("../assets/img/line.png");
          background-repeat: no-repeat;
          background-position: center center;
          background-size: contain;
          -webkit-transform: translateY(-50%);
          -moz-transform: translateY(-50%);
          -ms-transform: translateY(-50%);
          -o-transform: translateY(-50%);
        }
      }
    }
    // 工作环境
    .work {
      .con {
        .work_content {
          height: 6rem;
          width: 100%;
          margin-top: 0.8rem;
          .work_ul {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 0.4rem;
            li {
              margin-top: 0.3rem;
              width: 3.8rem;
              height: 2.88rem;
              cursor: pointer;
              .li_img {
                width: 100%;
                height: 100%;
                overflow: hidden;
                img {
                  width: 100%;
                  transition: all 0.5s;
                }
              }
            }
            .work_li:hover {
              .li_img {
                img {
                  transform: scale(1.2);
                }
              }
            }
          }
          // .m_work_ul {
          //   display: none;
          // }
        }
      }
    }
    // 企业关怀
    .care {
      .container {
        .care_content,
        .m_care_content {
          height: 6rem;
          width: 100%;
          display: flex;
          margin-top: 0.7rem;
          .care_img {
            width: 33.33%;
            height: 4.4rem;
            position: relative;
            cursor: pointer;
            img {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
            }
            .care_img_opt {
              position: absolute;
              width: 100%;
              height: 100%;
              background-color: #000000a8;
              opacity: 1;
              transition: opacity 1s;
              .opt_img {
                width: 0.7rem;
                height: 0.7rem;
                position: relative;
                left: 50%;
                transform: translateX(-50%);
                top: 1rem;
                .pic {
                  width: 0.7rem;
                  height: 0.7rem;
                  padding: 0.1rem;
                  position: absolute;
                }
              }
              .opt_text {
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                top: 2rem;
                h4 {
                  font-size: 0.24rem;
                  color: #fff;
                  text-align: center;
                  padding-bottom: 0.1rem;
                }
                p {
                  font-size: 0.12rem;
                  color: #fff;
                  text-align: center;
                  line-height: 0.16rem;
                }
              }
            }
            .care_img_opt:hover {
              opacity: 0;
            }
          }
        }
      }
    }
  }
  @media only screen and (max-width: 766px) {
    .banner {
      .container {
        .btn {
          .campus_btn {
            left: 29%;
          }
        }
      }
    }

    .content {
      // 职场发展{}
      .workplace {
        height: 12rem;
        .container {
          .p_box {
            .box_btm {
              height: 8rem;
              flex-direction: column;
              .box_btm_l,
              .box_btm_r {
                width: 100%;
                height: 2rem;
              }
              .box_m {
                margin: 0.4rem 0;
                width: 100%;
                height: 100%;
                display: flex;
                background-color: #d0e7f9;
                border-radius: 0.2rem;

                .m_ul {
                  width: 2rem;
                  .ul_last {
                    height: 100%;
                    font-family: "Noto Sans SC";
                    width: 2rem;
                    text-align: center;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    justify-content: space-evenly;
                  }
                }
              }
              .box_m > .box_btm_c {
                overflow-x: scroll;
                overflow-y: visible;
                position: relative;
                width: calc(100%-2rem);
                .con_ul {
                  li {
                    width: 2.6rem;
                  }
                  .dian::after {
                    left: 0.6rem;
                    width: 1.2rem;
                    align-content: center;
                  }
                  // .jt::after {
                  //   content: "";
                  //   position: absolute;
                  //   background-image: url("../assets/img/arrow_02.png");
                  //   background-size: 100%;
                  //   background-repeat: no-repeat;
                  //   background-position: center;
                  //   width: 0.4rem;
                  //   height: 1.6rem;
                  //   bottom: 0;
                  // }
                }
                .jt {
                  position: relative;
                }

                .ul_last {
                  position: relative;
                }
                .con_ul:nth-child(1) {
                  margin-left: 8.2rem;
                }
              }
            }
          }
        }
      }
      // 1
      .company {
        height: 14rem;
        .container {
          .company_content {
            flex-flow: column;
            height: 10rem;
            .company_content_l {
              width: 100%;
              height: 4.95rem;
              order: 2;
              padding: 0;
            }
            .company_content_r {
              width: 100%;
              height: 5.25rem;
              order: 1;
            }
          }
        }
      }
      // 2
      .personnel {
        height: 5.8rem;
        .container {
          .personnel_swiper {
            margin-top: 0.46rem;
          }
        }
      }
      // 3
      .staff {
        .container {
          .staff_centent {
            display: none;
          }
          .m_staff_centent {
            display: block !important;
            margin-top: 0.6rem;
          }
          .staff_item {
            width: 3.2rem;
            height: 2rem;
            .text {
              p {
                font-size: 0.3rem !important;
              }
            }
          }
        }
      }
      // 5
      .pay {
        height: 7rem;
        .container {
          // .pay_content {
          //   flex-wrap: wrap;
          //   li {
          //     width: 50%;
          //     padding: 0.5rem 0;
          //     p {
          //       font-size: 0.24rem;
          //     }
          //   }
          // }
          .xc {
            width: 100%;
            .slide_1 {
              display: none;
            }
            .slide2-svg {
              display: none;
            }
            .a1 {
              left: 1rem;
              top: 0.9rem;
            }
            .a2 {
              left: 0.4rem;
              top: 1.6rem;
            }
            .a3 {
              left: 0rem;
              top: 3rem;
            }
            .a4 {
              left: 1.5rem;
              top: 3.8rem;
            }
            .a5 {
              left: 5.6rem;
              top: 3.8rem;
            }
            .a6 {
              left: 6.6rem;
              top: 3rem;
            }
            .a7 {
              left: 6.6rem;
              top: 1.6rem;
            }
            .a8 {
              left: 5.6rem;
              top: 0.8rem;
            }
            .a9 {
              left: 1.9rem;
              top: 1.5rem;
            }
            .a10 {
              left: 1.8rem;
              top: 3rem;
            }
            .a11 {
              left: 5rem;
              top: 3rem;
            }
            .a12 {
              left: 4.8rem;
              top: 1.3rem;
            }
          }
        }
      }
      // 6
      .recruit {
        .container {
          .recruit_con {
            overflow: auto;

            .li:nth-child(odd) {
              .box {
                .text {
                  bottom: -0.4rem;
                }
              }
            }
            .li:nth-child(even) {
              .box {
                .text {
                  top: -0.4rem;
                }
              }
            }
          }
          .recruit_con::after {
            width: 12rem;
          }
        }
      }
      // 7
      .work {
        .con {
          .work_content {
            height: 6rem;
            .work_ul {
              display: none;
              height: 100%;
            }
            .m_work_ul {
              display: block;
              height: 100%;
              margin-top: 0.4rem;
            }
          }
        }
      }
      // 8
      .care {
        .container {
          .m_care_content {
            height: 6.8rem;
            display: block;
            overflow: hidden;
            .care_img {
              width: 100%;
              height: 100%;
              .care_img_opt {
                .opt_img {
                  top: 2rem;
                }
                .opt_text {
                  top: 3rem;
                  p {
                    line-height: 0.32rem;
                    font-size: 0.24rem;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  @media only screen and (max-width: 500px) {
    .banner {
      .container {
        .btn {
          div {
            width: 1.4rem;
            height: 0.68rem;
            line-height: 0.68rem;
            font-size: 0.24rem;
            padding: 0;
            text-align: center;
          }
        }
      }
    }
    .content {
      // 1
      .company {
        .container {
          .company_content {
            .company_content_l {
              p:nth-child(1) {
                margin: 0 0.4rem;
                margin-top: 0.4rem;
              }
              p:nth-child(2) {
                margin: 0 0.4rem;
                margin-bottom: 0.4rem;
              }
            }
          }
        }
      }
    }
  }
}
@media only screen and (max-width: 766px) {
  .home {
    margin-top: 1.4rem;

    .content {
      .company {
        .container {
          .company_content {
            .company_content_l {
              p {
                font-size: 0.24rem;
              }
            }
          }
        }
      }
    }
  }
}
</style>
